<template>
  <div id="sideNav" class="scrollHide" scroll>
    <nav>
      <transition name="fade" mode="out-in" :duration="200">
        <!-- 客户 -->
        <div v-if="routeList[1]=='client'" :key="'client'" class="client">
          <div class="menuList tra tra-fast_E">
            <router-link to="/client/home" :title="$t('cmd1',['首页'])">
              <span class="fa fa-home"></span>
              <span class="name tra">{{$t("cmd1",["首页"])}}</span>
            </router-link>
            <router-link to="/client/clue" :title="$t('word1185',['线索'])">
              <span class="fa fa-connectdevelop"></span>
              <span class="name tra">{{$t("word1185",["线索"])}}</span>
            </router-link>
            <router-link to="/client/customer" :title="$t('word1183',['客户'])">
              <span class="fa fa-group"></span>
              <span class="name tra">{{$t("word1183",["客户"])}}</span>
            </router-link>
          </div>
        </div>
        <!-- 运营 -->
        <div v-if="routeList[1]=='maintain'" :key="'maintain'" class="maintain">
          <div class="menuList tra tra-fast_E"  v-if='userInfo.organization.operateObject.indexOf("2") !== -1'>
            <router-link to="/maintain/dataCockpit" :title="getLanguageStr('plant371','数据驾驶舱')">
              <Icon name="menu-13" />
              <span class="name tra">{{getLanguageStr('plant371','数据驾驶舱')}}</span>
            </router-link>
          </div>
           <button class="menuClass tra" status="show" :title="getLanguageStr('plant373','光伏电站')" type="button" @click="displaySubmenu($event.currentTarget)" v-if='userInfo.organization.operateObject.indexOf("2") !== -1'>
            <Icon name="plant" />
            <span class="name tra">{{getLanguageStr('plant373','光伏电站')}}</span>
            <span class="fa fa-angle-right tra-fast"></span>
          </button>
          <div class="menuList tra tra-fast_E">
            <router-link v-permissions="'A/A'" permission-type="none" to="/maintain/home" :title="$t('cmd1',['首页'])">
              <Icon name="home" />
              <span class="name tra">{{$t("cmd1",["首页"])}}</span>
            </router-link>
            <router-link v-permissions="'A/B/A1'" permission-type="none" to="/maintain/plant" :title="getLanguageStr('word204','电站')">
              <Icon name="plant" />
              <span class="name tra">{{getLanguageStr("word204","电站")}}</span>
            </router-link>
            <router-link v-permissions="'A/D/A1'" permission-type="none" to="/maintain/light/alarm?powerType=PV" :title="getLanguageStr('plant_alert1','电站内报警')">
              <Icon name="alarm" />
              <span class="name tra">{{getLanguageStr("plant_alert1","电站内报警")}}</span>
            </router-link>
            <router-link v-permissions="'A/B/A7'" permission-type="none" to="/maintain/light/device?powerType=PV" :title="getLanguageStr('plant_device1','电站内设备')">
              <Icon name="menu-layer" />
              <span class="name tra">{{getLanguageStr("plant_device1","电站内设备")}}</span>
            </router-link>
          </div>
          <button class="menuClass tra" v-if='userInfo.organization.operateObject.indexOf("2") !== -1' status="show" :title="getLanguageStr('plant374','风力电站')" type="button" @click="displaySubmenu($event.currentTarget)">
            <Icon name="plant-wind" />
            <span class="name tra">{{getLanguageStr('plant374','风力电站')}}</span>
            <span class="fa fa-angle-right tra-fast"></span>
          </button>
         <div class="menuList tra tra-fast_E" v-if='userInfo.organization.operateObject.indexOf("2") !== -1'>
            <router-link v-permissions="'A/A'" permission-type="none" to="/maintain/wind/home" :title="$t('cmd1',['首页'])">
              <Icon name="home" />
              <span class="name tra">{{$t("cmd1",["首页"])}}</span>
            </router-link>
            <router-link v-permissions="'A/B/A1'" permission-type="none" to="/maintain/wind/plant" :title="getLanguageStr('word204','电站')">
              <Icon name="plant-wind" />
              <span class="name tra">{{getLanguageStr("word204","电站")}}</span>
            </router-link>
            <router-link v-permissions="'A/D/A1'" permission-type="none" to="/maintain/wind/alarm?powerType=WIND" :title="getLanguageStr('plant_alert1','电站内报警')">
              <Icon name="alarm" />
              <span class="name tra">{{getLanguageStr("plant_alert1","电站内报警")}}</span>
            </router-link>
            <router-link v-permissions="'A/B/A7'" permission-type="none" to="/maintain/wind/device?powerType=WIND" :title="getLanguageStr('plant_device1','电站内设备')">
              <Icon name="menu-layer" />
              <span class="name tra">{{getLanguageStr("plant_device1","电站内设备")}}</span>
            </router-link>
          </div> 
          <!-- <div class="menuList tra tra-fast_E">
            <router-link v-permissions="'A/A'" permission-type="none" to="/maintain/home" :title="$t('cmd1',['首页'])">
              <Icon name="home" />
              <span class="name tra">{{$t("cmd1",["首页"])}}</span>
            </router-link>
            <router-link v-permissions="'A/B/A1'" permission-type="none" to="/maintain/plant" :title="getLanguageStr('word204','电站')">
              <Icon name="plant" />
              <span class="name tra">{{getLanguageStr("word204","电站")}}</span>
            </router-link>
            <router-link v-permissions="'A/D/A1'" permission-type="none" to="/maintain/alarm" :title="getLanguageStr('plant_alert1','电站内报警')">
              <Icon name="alarm" />
              <span class="name tra">{{getLanguageStr("plant_alert1","电站内报警")}}</span>
            </router-link>
            <router-link v-permissions="'A/B/A7'" permission-type="none" to="/maintain/device" :title="getLanguageStr('plant_device1','电站内设备')">
              <Icon name="menu-layer" />
              <span class="name tra">{{getLanguageStr("plant_device1","电站内设备")}}</span>
            </router-link>
          </div> -->
        </div>
        <!-- 项目 -->
        <div v-if="routeList[1]=='project'" :key="'project'" class="project">
          <div class="menuList tra tra-fast_E">
            <router-link to="/project/home" :title="$t('cmd1',['首页'])">
              <svg>
                <use xlink:href="#ico-house" /></svg>
              <span class="name tra">{{$t("cmd1",["首页"])}}</span>
            </router-link>
            <router-link to="/project/project/list" :title="$t('word1202',['项目'])">
              <svg>
                <use xlink:href="#ico-project" /></svg>
              <span class="name tra">{{$t('word1202',['项目'])}}</span>
            </router-link>
          </div>
        </div>
        <!-- 管理 -->
        <div v-if="routeList[1]=='manage'" :key="'manage'" class="manage">
          <div class="menuList tra tra-fast_E">
            <router-link to="/manage/provider" v-permissions="'D/C/A1'" permission-type="none" :title="getLanguageStr('word1652','关于商家')">
              <Icon name="serviceprovider" />
              <span class="name tra">{{getLanguageStr('word1652','关于商家')}}</span>
            </router-link>
          </div>

          <button v-permissions="'D/A/A1'" permission-type="none" class="menuClass tra" status="show" :title="getLanguageStr('word1621','内部组织架构')" type="button" @click="displaySubmenu($event.currentTarget)">
            <Icon name="menu-users" />
            <span class="name tra">{{getLanguageStr('word1621','内部组织架构')}}</span>
            <span class="fa fa-angle-right tra-fast"></span>
          </button>
          <div class="menuList tra tra-fast_E" v-permissions="'D/A/A1'" permission-type="none">
            <router-link v-permissions="'D/A/A2'" permission-type="none" to="/manage/memberAuth/groupMember" :title="getLanguageStr('word1733','部门/成员')">
              <Icon name="menu-user" />
              <span class="name tra">{{getLanguageStr('word1733','部门/成员')}}</span>
            </router-link>
            <router-link v-permissions="'D/A/A6'" permission-type="none" to="/manage/memberAuth/roles" :title="getLanguageStr('word90','角色')">
              <Icon name="menu-user-option" />
              <span class="name tra">{{getLanguageStr('word90','角色')}}</span>
            </router-link>
          </div>
          <button v-permissions="'D/D/A1'" permission-type="none" class="menuClass tra" status="show" :title="getLanguageStr('word1927','外部关系管理')" type="button" @click="displaySubmenu($event.currentTarget)">
            <Icon name="outRelation" />
            <span class="name tra">{{getLanguageStr('word1927','外部关系管理')}}</span>
            <span class="fa fa-angle-right tra-fast"></span>
          </button>
          <div class="menuList tra tra-fast_E" v-permissions="'D/D/A1'" permission-type="none">
            <router-link v-if='hasout' v-permissions="'D/D/A2'" permission-type="none" to="/manage/external/relation" :title="getLanguageStr('word1654','外部关系')">
              <Icon name="outRelations" />
              <span class="name tra">{{getLanguageStr('word1654','外部关系')}}</span>
            </router-link>
            <router-link v-permissions="'D/D/A10'" permission-type="none" to="/manage/external/roles" :title="getLanguageStr('word1655','外部角色')">
              <Icon name="outRole" />
              <span class="name tra">{{getLanguageStr('word1655','外部角色')}}</span>
            </router-link>
          </div>
          <div class="menuList tra tra-fast_E">
            <router-link v-permissions="'D/B/A1'" permission-type="none" to="/manage/tag" :title="$t('word1471',['标签'])">
              <Icon name="menu-tag" />
              <span class="name tra">{{$t("word1471",["标签"])}}</span>
            </router-link>
          </div>
          <button class="menuClass tra" status="show" :title="getLanguageStr('word1934','消息管理')" type="button" @click="displaySubmenu($event.currentTarget)" v-permissions="'D/E'" permission-type="none" v-if="!stage.setting.loc.shieldBlackList.message">
            <i class="fa fa-bell"></i>
            <span class="name tra">{{getLanguageStr('word1934','消息管理')}}</span>
            <span class="fa fa-angle-right tra-fast"></span>
          </button>
          <div class="menuList tra tra-fast_E" v-if="!stage.setting.loc.shieldBlackList.managemessage">
            <router-link to="/manage/message" :title="getLanguageStr('word1955','报警消息')" v-permissions="'D/E/A1'" permission-type="none">
              <Icon name="alarm" />
              <span class="name tra">{{getLanguageStr('word1955','报警消息')}}</span>
            </router-link>
          </div>
        </div>
        <!-- 设备 -->
        <div v-if="routeList[1]=='device'" :key="'device'" class="device ">
          <div class='menuList tra tra-fast_E'>
            <router-link to="/device/home" v-permissions="'B/H/A1'" permission-type="none" :title="getLanguageStr('cmd1','首页')">
            <Icon name="home" />
            <span class="name tra">{{getLanguageStr("cmd1","首页")}}</span>
            </router-link>
            <router-link to="/device/device" v-permissions="'B/A/A1'" permission-type="none" :title="getLanguageStr('device5','设备库')">
              <Icon name="menu-layer" />
              <span class="name tra">{{getLanguageStr("device5","设备库")}}</span>
            </router-link>
            <router-link v-permissions="'B/D/A1'" permission-type="none" to="/device/operationalAudit" :title="getLanguageStr('word1660','操作日志')">
              <Icon name="menu-data-on" />
              <span class="name tra">{{getLanguageStr("word1660",'操作日志')}}</span>
            </router-link>
          </div>
         
          <!--  userInfo.organization.id==1-->
          

          <!-- <button v-permissions="'B/A'" permission-type="none" class="menuClass tra" status="show" type="button" @click="displaySubmenu($event.currentTarget)">
					<Icon name="menu-4" />
					<span class="name tra">{{getLanguageStr("word1624","接入")}}</span>
					<span class="fa fa-angle-right tra-fast"></span>
				</button> -->
          <div class="menuList tra tra-fast_E" v-permissions="'B/A/A1'" permission-type="none">
            <!-- 产品说不做 -->
            <!-- <router-link to="/device/home">
					<svg><use xlink:href="#ico-house" /></svg>
					<span class="name tra" >{{$t("cmd1",["首页"])}}</span>
				</router-link> -->
            <!-- <router-link to="/device/device">
					<Icon name="menu-layer" />
					<span class="name tra" >{{getLanguageStr("word164","设备")}}</span>
				</router-link>
				 -->
          </div>
          <!-- <button v-permissions="'B/B'" permission-type="none" class="menuClass tra" status="show" type="button" @click="displaySubmenu($event.currentTarget)">
				<Icon name="menu-3" />
				<span class="name tra">{{getLanguageStr("word1517","扩展服务")}}</span>
				<span class="fa fa-angle-right tra-fast"></span>
			</button>
			<div class="menuList tra tra-fast_E">
				<router-link v-permissions="'B/D/A1'" permission-type="none" to="/device/operationalAudit">
					<Icon name="menu-data-on" />
					<span class="name tra" >{{getLanguageStr("word1518","操作审计")}}</span>
				</router-link>
				<router-link v-permissions="'B/B/A2'" permission-type="none" to="/device/firmware">
					<Icon name="menu-2" />
					<span class="name tra" >{{$t('word217',['固件管理'])}}</span>
				</router-link>
			</div> -->
        </div>
        <div v-if="routeList[1]=='product'" :key="'product'" class="product">
          <div class='menuList tra tra-fast_E'>
            <router-link v-permissions="'B/E/A1'" permission-type="none" to="/product/List" :title="getLanguageStr('product2','产品管理')">
            <Icon name="productManage" />
            <span class="name tra">{{getLanguageStr('product2','产品管理')}}</span>
          </router-link>
          <router-link v-permissions="'B/B/A2'" permission-type="none" to="/product/firmware" :title="$t('word217',['固件管理'])">
            <Icon name="menu-2" />
            <span class="name tra">{{$t('word217',['固件管理'])}}</span>
          </router-link>
          <router-link v-if="stage.setting.loc.shieldWhiteList.orderManagement" v-permissions="'E/A/A1'" permission-type="none" to="/product/orderManagement" :title="$t('device290',['指令管理'])">
            <Icon name="menu-14" />
             <span class="name tra">{{$t('device290',['指令管理'])}}</span>
          </router-link>
          <router-link v-permissions="'B/F/A1'" v-if='!stage.setting.loc.shieldBlackList.batchTask' permission-type="none" to="/product/batchTask" :title="getLanguageStr('task1','批量任务')">
            <Icon name="batchmenu" />
            <span class="name tra">{{getLanguageStr("task1",'批量任务')}}</span>
          </router-link>
          <router-link  v-if="!stage.setting.loc.shieldBlackList.archives" v-permissions="'B/G/A1'" permission-type="none" to="/product/infoMaintenance" :title="getLanguageStr('device_file1','设备档案')">
              <Icon name="dv-logger" />
              <span class="name tra">{{getLanguageStr("device_file1",'设备档案')}}</span>
              <!-- <span class="fa fa-angle-right tra-fast"></span> -->
          </router-link>
          </div>
          
          <!-- 
            <button v-if="stage.loc.customer=='SOLARMAN'" v-permissions="'B/G'" permission-type="none" class="menuClass tra" status="show" type="button" @click="displaySubmenu($event.currentTarget)">
              <Icon name="dv-logger" />
              <span class="name tra">{{getLanguageStr("device_file1",'设备档案')}}</span>
              <span class="fa fa-angle-right tra-fast"></span>
            </button>
            <div class="menuList tra tra-fast_E">
            <router-link to="/product/infoMaintenance" v-permissions="'B/G/A1'" permission-type="none">
              <Icon name="deploy" />
              <span class="name tra">{{getLanguageStr("word1886",'配置信息维护')}}</span>
            </router-link>
             <router-link to="/product/collectorFastConfig/" v-if="stage.loc.customer=='SOLARMAN'" v-permissions="'B/G/A2'" permission-type="none">
              <Icon name="list" />
              <span class="name tra">{{getLanguageStr("word1913",'国网扶贫')}}</span>
            </router-link>
          </div> -->
        </div>
        <div v-if="routeList[1]=='sim'" :key="'sim'" class="sim sim-basicInfo sim-card">
          <!--purch production keeper operation-->
          <!-- 基础信息管理 -->
          <button class="menuClass tra purch" status="hide" type="button" @click="displaySubmenu($event.currentTarget)">
            <svg>
              <use xlink:href="#ico-userCertified" /></svg>
            <span class="name tra">{{getLanguageStr('word1642','基础信息')}}</span>
            <span class="fa fa-angle-right tra-fast"></span>
          </button>
          <div class="menuList tra tra-fast_E">
            <router-link to="/sim/basicInfo/accountCreate">
              <span class="name tra">{{getLanguageStr('manage361','账号创建')}}</span>
            </router-link>
            <router-link to="/sim/basicInfo/AccountAuth">
              <span class="name tra">{{getLanguageStr('assess6','权限管理')}}</span>
            </router-link>
          </div>
          <!-- 采购操作 -->
          <button class="menuClass tra purch" status="hide" type="button" @click="displaySubmenu($event.currentTarget)">
            <svg>
              <use xlink:href="#ico-userCertified" /></svg>
            <span class="name tra">采购</span>
            <span class="fa fa-angle-right tra-fast"></span>
          </button>
          <div class="menuList tra tra-fast_E">
            <router-link to="/sim/card/purch/check">
              <span class="name tra">采购登记</span>
            </router-link>
          </div>
          <!-- 生产操作 -->
          <button class="menuClass tra production" status="hide" type="button" @click="displaySubmenu($event.currentTarget)">
            <span class="fa fa-home"></span>
            <span class="name tra">生产</span>
            <span class="fa fa-angle-right tra-fast"></span>
          </button>
          <div class="menuList tra tra-fast_E">
            <router-link to="/sim/card/production/outstorage">
              <span class="fa fa-home"></span>
              <span class="name tra">申请出库</span>
            </router-link>
            <router-link to="/sim/card/production/receive">
              <span class="fa fa-home"></span>
              <span class="name tra">接收确认</span>
            </router-link>
            <router-link to="/sim/card/production/restorage">
              <span class="fa fa-home"></span>
              <span class="name tra">返库申请</span>
            </router-link>
          </div>
          <!-- 库管操作 -->
          <button class="menuClass tra keeper" status="hide" type="button" @click="displaySubmenu($event.currentTarget)">
            <span class="fa fa-home"></span>
            <span class="name tra">库管</span>
            <span class="fa fa-angle-right tra-fast"></span>
          </button>
          <div class="menuList tra tra-fast_E">
            <router-link to="/sim/card/keeper/instorage">
              <span class="fa fa-home"></span>
              <span class="name tra">入库登记</span>
            </router-link>
            <router-link to="/sim/card/keeper/Card">
              <span class="fa fa-home"></span>
              <span class="name tra">卡号分配</span>
            </router-link>
            <router-link to="/sim/card/keeper/outcheck">
              <span class="fa fa-home"></span>
              <span class="name tra">出库登记</span>
            </router-link>
            <router-link to="/sim/card/keeper/scrap">
              <span class="fa fa-home"></span>
              <span class="name tra">返库申请</span>
            </router-link>
          </div>
          <!-- 库管操作 -->
          <button class="menuClass tra keeper" status="hide" type="button" @click="displaySubmenu($event.currentTarget)">
            <span class="fa fa-home"></span>
            <span class="name tra">产品</span>
            <span class="fa fa-angle-right tra-fast"></span>
          </button>
          <div class="menuList tra tra-fast_E">
            <router-link to="/sim/card/product/delivery">
              <span class="fa fa-home"></span>
              <span class="name tra">产品出库</span>
            </router-link>
            <router-link to="/sim/card/product/redelivery">
              <span class="fa fa-home"></span>
              <span class="name tra">二次发货</span>
            </router-link>
            <router-link to="/sim/card/product/returnlib">
              <span class="fa fa-home"></span>
              <span class="name tra">退货入库</span>
            </router-link>
          </div>
          <!-- 运营操作 -->
          <button class="menuClass tra operation" status="hide" type="button" @click="displaySubmenu($event.currentTarget)">
            <span class="fa fa-home"></span>
            <span class="name tra">{{$t('word1184',['运营'])}}</span>
            <span class="fa fa-angle-right tra-fast"></span>
          </button>
          <div class="menuList tra tra-fast_E">
            <router-link to="/sim/card/operation/scrapcheck">
              <span class="fa fa-home"></span>
              <span class="name tra">返库报废</span>
            </router-link>
            <router-link to="/sim/card/operation/change">
              <span class="fa fa-home"></span>
              <span class="name tra">换卡操作</span>
            </router-link>
          </div>
          <!-- 售后 -->
          <button class="menuClass tra operation" status="hide" type="button" @click="displaySubmenu($event.currentTarget)">
            <span class="fa fa-home"></span>
            <span class="name tra">售后</span>
            <span class="fa fa-angle-right tra-fast"></span>
          </button>
          <div class="menuList tra tra-fast_E">
            <router-link to="/sim/card/aftersale/returnback">
              <span class="fa fa-home"></span>
              <span class="name tra">退换货</span>
            </router-link>
            <router-link to="/sim/card/aftersale/changecard">
              <span class="fa fa-home"></span>
              <span class="name tra">换卡</span>
            </router-link>
          </div>
        </div>
        <!-- 个人设置 -->
        <div v-if="routeList[1]=='setting'" :key="'setting'" class="setting">
          <div class="menuList tra tra-fast_E">
            <router-link v-permissions="'A/A'" permission-type="none" to="/setting/home">
              <Icon name="menu-user" />
              <span class="name tra">{{$t("me8",["个人信息"])}}</span>
            </router-link>
            <router-link v-permissions="'A/A'" permission-type="none" to="/setting/preference">
              <Icon name="menu-user" />
              <span class="name tra">{{$t("me9",["偏好设置"])}}</span>
            </router-link>
          </div>
        </div>
      </transition>
    </nav>
  </div>
</template>
<script>
import * as lib from '@/util/lib.js'
import { mapGetters } from 'vuex';
import { getLanguageStr } from '@/util/language.js'

function resize () {
  if ($('#sideNav nav').height() > $('#sideNav').height()) {
    $('#sideNav').addClass('hasScroll')
  }
}
export default {
  components: {},
  watch: {
    $route () {
      // this.routeList=lib.setSideNav(this.$route.path.split('/'),this.routeList);
      this.routeList = this.$route.path.split('/')
      this.$nextTick(function () {
        if ($('.active').parents('.' + this.routeList[1]).length > 0) { // 自动展开当前激活的父级
          if (this.routeList[1] == 'sim') {
            this.displaySubmenu($('.active').parents('.' + this.routeList[1] + '-' + this.routeList[2]).find('button.' + this.routeList[this.routeList.length - 1])[0], 'show')
          } else {
            this.displaySubmenu($('.' + this.routeList[1] + ' .menuClass[status]')[0], 'show')
          }
        }
      })
    }
  },
  data () {
    return {
      stage,
      list: [{ name: '1' }, { name: '2' }],
      routeList: [],
      hasout: true
    }
  },
  methods: {
    getLanguageStr,
    displaySubmenu: function (dom, action) {
      let $target = $(dom)
      if (action) $target.attr('status', action)
      else {
        if ($target.attr('status') === 'show') {
          $target.attr('status', 'hide')
        } else {
          $target.attr('status', 'show')
        }
      }
      setTimeout(resize, 600)
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/userInfo'
    })
  },
  mounted () {
    let perms = localStorage.getItem('buttonPermissions')
    let hasout = perms.includes('D/D/A2') || perms.includes('D/D/A6')
    this.hasout = hasout
    var vue = this
    this.routeList = lib.setSideNav(this.$route.path.split('/'), this.routeList)
    if ($('.active').parents('.' + this.routeList[1]).length > 0) { // 自动展开当前激活的父级
      if (this.routeList[1] == 'sim') {
        this.displaySubmenu($('.active').parents('.' + this.routeList[1] + '-' + this.routeList[2]).find('button.' + this.routeList[this.routeList.length - 1])[0], 'show')
      } else {
        this.displaySubmenu($('.' + this.routeList[1] + ' .menuClass[status]')[0], 'show')
      }
    }
    lib.setScroll($('#sideNav'))
    resize()
    $(window).resize(resize)
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/frame/SideNav.vue